<template>
  <div class="login-wrap">
    <div class="lw-hd">申请管理后台</div>
    <div class="lw-info">Welcome!</div>
    <el-form :model="loginForm" class="loginForm" :rules="loginRules" ref="loginForm">
      <el-form-item prop="userName">
        <el-input class="border-bottom" v-model="loginForm.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input class="border-bottom" v-model="loginForm.password" placeholder="请输入密码" type="password"></el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-input class="border-bottom" v-model="loginForm.captcha" placeholder="请输入验证码"></el-input>
        <img :src="codeSrc" alt="" class="captcha" @click="getCaptcha">
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="loginBtn" @click="toLogin" :loading="isSubmit">登录</el-button>
        <!--<div class="forget"><a href="javascript:;" @click="$router.replace({path:'/assist/forget'})">忘记密码?</a></div>-->
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    mapMutations
  } from 'vuex'
  import {saveLocal, readLocal} from '@/assets/js/common'

  export default {
    data () {
      return {
        loginForm: {
          userName: '',
          password: '',
          captcha: ''
        },
        loginRules: {
          userName: [{required: true, message: '请输入用户名', trigger: ['blur']}],
          password: [{required: true, message: '请输入密码', trigger: ['blur']}],
          captcha: [{required: true, message: '请输入验证码', trigger: ['blur']}]
        },
        codeSrc: '',
        isSubmit: false
      }
    },
    created () {
      let oldInfo = readLocal('userLogin', 'loginAccount')
      if (oldInfo) {
        this.loginForm.userName = oldInfo
      }
      this.setUserInfo(null)
      this.getCaptcha()
    },
    methods: {
      ...mapMutations(['setToken', 'setUserInfo']),
      getCaptcha () {
        this.$api.captcha(res => {
          this.codeSrc = res.img
          this.setToken(res.token)
        })
      },
      toLogin () {
        let _this = this
        _this.$refs['loginForm'].validate(valid => {
          if (valid) {
            _this.isSubmit = true
            let json = JSON.parse(JSON.stringify(_this.loginForm))
            _this.$api.login(json, (res) => {
              _this.setToken(res.token)
              saveLocal('userToken', 'token', res.token)
              saveLocal('userToken', 'loginAccount', json.userName)
              this.$router.replace({path: '/'})
            }, () => {
              _this.isSubmit = false
            }, () => {
              _this.getCaptcha()
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .login-wrap {
    width: 300px;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 100px;
  }

  .lw-hd {
    text-align: center;
    font-size: 30px;
    color: #4292ff;
    font-family: -webkit-pictograph;
    line-height: 35px;
  }

  .lw-info {
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 18px;
  }

  .loginForm {
    padding-top: 40px;
  }

  .captcha {
    position: absolute;
    width: 80px;
    height: 34px;
    top: 0;
    right: 0;
  }

  .loginBtn {
    width: 100%;
  }

  .forget {
    text-align: right;

    a {
      color: #999;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/assist/login/index.vue